import { type ShouldTriggerAutosaveSource } from '@bizzdesign/modeler/models';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const frameCreationSnackbarUiEvents = eventGroup({
  source: 'Frame Creation Snackbar UI',
  events: {
    creationStarted: type<{ source: ShouldTriggerAutosaveSource }>(),
    creationCompleted: type<void>(),
  },
});
